import React, { cloneElement } from 'react';
import styled from '@emotion/styled';
import css from '@styled-system/css';

import { getInputStateType } from '../../../forms/Input/getInputStateType';
import { BaseFlex } from '../../../layouts/Flex/Flex';

export const Container = styled(BaseFlex)((props) => {
  const { reverse } = props;
  const type = getInputStateType(props);

  return css({
    position: 'absolute',
    width: 'input.icon.container',
    right: reverse ? 0 : 'unset',
    left: !reverse ? 0 : 'unset',
    height: '100%',
    pointerEvents: 'none',
    color: `input.${type}.icon`,
  });
});

export const IconContainer = styled(BaseFlex)(
  css({
    margin: 'auto',
  })
);

const Icon = ({ icon, color, size = 'small', ...rest }) => {
  return (
    <Container icon={icon} color={color} size={size} {...rest}>
      <IconContainer>
        {cloneElement(icon, {
          color: color ? color : 'inherit',
        })}
      </IconContainer>
    </Container>
  );
};

export default Icon;
